import { useState } from 'react';
import { Skeleton } from 'antd';
import { Common, Widget } from '@stockbit/ui';
import { Table } from '../styled';

const { Text, Input } = Common;
const { Button } = Widget;

const columns = [
  {
    dataIndex: 'label',
    key: 'label',
    width: '60%',
  },
  {
    dataIndex: 'value',
    key: 'value',
  },
];

interface ValuationResultTypes {
  onClick: (data: string) => void;
  dataValuationResult: {
    target_price: string;
    current_price: string;
    margin_safety: string;

    consensus_high: string;
    consensus_low: string;
    consensus_medium: string;

    symbol: string;
  };
  isUpdateMode: boolean;
  notes: string;
  isLoading: boolean;
}

const ValuationResult = ({
  onClick,
  dataValuationResult,
  isUpdateMode,
  notes,
  isLoading,
}: ValuationResultTypes) => {
  const [inputedNotes, setInputedNotes] = useState('');

  const handleOnChangeNotes = (e) => {
    setInputedNotes(e.target.value.trim());
  };

  const handleOnClickResult = () => {
    onClick(inputedNotes);
  };

  const dataSourceStockValue = [
    {
      key: 1,
      label: `Target Price ${dataValuationResult.symbol}`,
      value: dataValuationResult.target_price,
    },
    {
      key: 2,
      label: `Current Price ${dataValuationResult.symbol}`,
      value: dataValuationResult.current_price,
    },
    {
      key: 3,
      label: 'Potential Gain',
      value: `${dataValuationResult.margin_safety} %`,
    },
  ];

  const dataSourceConsensusTarget = [
    {
      key: 1,
      label: 'Consensus (High)',
      value: dataValuationResult.consensus_high,
    },
    {
      key: 2,
      label: 'Consensus (Medium)',
      value: dataValuationResult.consensus_medium,
    },
    {
      key: 3,
      label: 'Consensus (Low)',
      value: dataValuationResult.consensus_low,
    },
  ];

  if (isLoading || !dataValuationResult.target_price) {
    return <Skeleton active />;
  }

  return (
    <div>
      <Text family="bold" mb="15px">
        Stock Value
      </Text>
      <Table
        columns={columns}
        dataSource={dataSourceStockValue}
        borderless
        pagination={false}
      />
      <Text family="bold" my="15px">
        Consensus Target
      </Text>
      <Table
        columns={columns}
        dataSource={dataSourceConsensusTarget}
        borderless
        pagination={false}
      />
      <Text family="bold" my="15px">
        Notes
      </Text>
      <Input.TextArea
        autoSize={{ minRows: 2 }}
        onChange={handleOnChangeNotes}
        defaultValue={isUpdateMode ? notes : ''}
      />
      <Button
        type="defaultHoverable"
        margin="15px 0"
        block
        round
        onClick={handleOnClickResult}
      >
        <Text align="center" height="27px" color="inherit">
          Save
        </Text>
      </Button>
    </div>
  );
};

export default ValuationResult;
